export default "__VITE_ASSET__DL2PVYEg__"